export const ManagerStudentDetailTranslations = {
  STUDENT_OF: {
    es: 'Estudiante de:',
    en: 'Student of:',
    cat: 'Estudiant de:',
    eus: 'Ikaslearen:',
    pt: 'Estudante de:'
  }
};
